export enum TabTheme {
  DEFAULT = 'default',
  CLASSIC = 'classic',
  HAS_BACKGROUND = 'has-background',
  IN_MODAL = 'in-modal',
  STRETCH = 'stretch',
}

export enum TabIconPosition {
  TOP = 'top',
  LEFT = 'left',
}
